import { normalizeVariationMatrix } from "./variationImageLock";

/**
 * Normalize static catalog / API product shapes for CheepSweepz UI.
 */

const EXPRESS_MULTIPLIER = 1.15;

const PUBLIC_PRODUCT_KEYS = [
  "product_id",
  "product_sku",
  "name",
  "title",
  "description",
  "marketplace",
  "category",
  "images",
  "real_images",
  "image_gallery_urls",
  "variation_matrix",
  "origin_marketplace",
  "origin_item_id",
  "is_verified_image",
  "is_catalog_image",
  "weight_lbs",
  "source_url",
  "landed_price",
  "pricing",
  "destination",
  "currency",
  "display_currency",
];

export function normalizeCatalogProduct(raw, options = {}) {
  if (!raw) return null;

  const destination = options.destination || "BB";
  const currency = options.currency || "USD";

  const landed = Number(
    raw.landed_price ?? raw.list_price ?? raw.pricing?.standard?.final_price
  );
  const safeLanded = Number.isFinite(landed) && landed > 0 ? landed : 0;

  const expressLanded =
    raw.pricing?.express?.final_price != null
      ? Number(raw.pricing.express.final_price)
      : Math.round(safeLanded * EXPRESS_MULTIPLIER * 100) / 100;

  const normalized = {
    product_id: raw.product_id,
    product_sku: raw.product_sku || raw.product_id,
    name: raw.name || raw.title || "Imported Item",
    title: raw.title || raw.name || "Imported Item",
    description:
      raw.description ||
      `${raw.name || "This item"} — all-inclusive import with customs, shipping, and clearance included.`,
    marketplace: raw.marketplace || raw.source_platform || "",
    category: raw.category || "General",
    images: raw.image_gallery_urls?.length ? raw.image_gallery_urls : raw.images || [],
    real_images: raw.real_images || raw.image_gallery_urls || [],
    image_gallery_urls: raw.image_gallery_urls || raw.real_images || raw.images || [],
    variation_matrix: normalizeVariationMatrix(raw.variation_matrix),
    origin_marketplace: raw.origin_marketplace || raw.marketplace || raw.source_platform || "",
    origin_item_id: raw.origin_item_id || raw.product_sku || raw.product_id,
    is_verified_image: Boolean(raw.is_verified_image),
    is_catalog_image:
      Boolean(raw.is_catalog_image) ||
      String(raw.product_id || "").startsWith("cs-") ||
      String(raw.product_id || "").startsWith("mp-"),
    weight_lbs: raw.weight_lbs,
    source_url: raw.source_url,
    landed_price: safeLanded,
    pricing: {
      standard: { final_price: safeLanded },
      express: { final_price: expressLanded },
    },
    destination,
    currency,
    display_currency: currency,
  };

  const publicProduct = {};
  for (const key of PUBLIC_PRODUCT_KEYS) {
    if (normalized[key] !== undefined) {
      publicProduct[key] = normalized[key];
    }
  }
  return publicProduct;
}
